// extracted by mini-css-extract-plugin
export default {"container":"kGC1M","container--m":"Vbfr1","container--s":"Gfz1M","tariff":"TvRuq","carousel":"aPGPg","wrapper":"nR74a","nav-btn":"qOQjK","next-btn":"GevYD","prev-btn":"Qvcqt"};